//@flow
import React from 'react';
import Nav from './src/navbar';

import {
  Actions as AppActions
} from 'app/actions';
import {
  Actions
} from './src/actions';
import {
  Validator
} from 'lib/idd-auth';
import {
  Container
} from 'flux/utils';

import appStore from 'app/store';
// import Loading from 'lib/Loading';

import {
  QueryRenderer,
  graphql
} from 'react-relay';
import env from 'app/relay/environment';
import css from './src/navbar.css';


const rootQuery = (graphql`query navbar_GetData_Query($brand:ID!) {
  user{
    brands(id:$brand){
      edges{
        node{
          modules{
            edges{
              node{
                name
              }
            }
          }
        }
      }
    }
  }
}
`);

type Props = {
  // location: Object
}
type State = {
  appStore: Object
}

class NavController extends React.Component<Props, State> {

  static getStores() {
    return [appStore];
  }

  static calculateState(prevState) {
    return {
      appStore: appStore.getState()
    };
  }


  render() {

    const brand = this.state.appStore.get("brand");

    return <QueryRenderer
      environment={env}
      query={rootQuery}
      variables={{ brand: brand ? brand.id : "nobrand" }}
      render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          const user = props.user ? props.user : null;
          if (!user) return null;
          const brand = user && user.brands.edges[0] ? user.brands.edges[0].node : null;
          let mainMenuItems = {
            'Dashboard': '/dashboard',
            'Evental': "",
            'Shout': "",
            // 'Taskd':"/taskd",
            'Directr': '/directr',
          };
          // console.log(props)
          if (brand && brand.modules.edges.find((module) => module.node.name === 'evental')) mainMenuItems.Evental = '/evental';
          if (brand && brand.modules.edges.find((module) => module.node.name === 'shout')) mainMenuItems.Shout = '/shout';

          const subMenuItems = {
            // 'Trackr': '/trackr',
            'Media Manager': '/media',
            'Manage Brand': '/directr/brand',

            'Switch Brand': () => {
              Actions.setShowMenu(false);
              AppActions.setBrandFocus(null);
            },
            'Log out': () => {
              //clear token cookie
              Validator.unsetToken();
              let r = "https://portal.indemand.digital";
              if (process.env.DEV_MODE === 'true') r = "http://localhost:3000/"
              window.location.href = "https://auth.indemand.digital/logout.hh?r=" + r;
            },
          }
          return <Nav data={props} mainMenuItems={mainMenuItems} subMenuItems={subMenuItems} {...this.props} />;
        } else {
          return <div className={css.container}>
            <div className={css.mainMenu}></div>
          </div>
        }
      }
      }
    />
  }
}
// export default InfoBarContainer
export default Container.create(NavController);